// @flow
import React, { Fragment } from "react";
import { Box, Button, Control, Input } from "biologiatotal-ui";
import Form from "../../../components/form";
import "./resetPassword.scss";

import formSchema from "./schema";

class ResetPassword extends Form {
  constructor(props: any) {
    super(props, formSchema);

    this.doRegister = this.doRegister.bind(this);
  }

  doRegister() {
    const { onRecover } = this.props;

    this.validate().then(
      () => onRecover(this.getValues()),
      () => null
    );
  }

  render() {
    const { values, errors } = this.state;

    return (
      <Fragment>
        <div className="columns reset-password">
          <div className="column centered is-4 is-offset-4">
            <Box className="reset-password-content">
              <div className="reset-password-header">
                <span>REDEFINIR SENHA</span>
              </div>
              <div>
                <span className="reset-password-header-texttwo">Insira e confirme a sua nova senha</span>
              </div>

              <div className="reset-password-form">
                <Control className="registerinput">
                  <span className="reset-password-form-label">Nova senha:</span>
                  <Input
                    className="reset-password-form-input"
                    value={values.password}
                    danger={errors.password}
                    placeholder="****"
                    onChange={e => this.update("password", e.target.value)}
                    type="password"
                  />
                  <p className="help is-danger reset-password-form-info">{errors.password}</p>
                </Control>
                <div className="reset-password-info-password">
                  Sua senha deve ter pelo menos 8 caracteres contendo letras e números
                </div>
                <Control className="registerinput">
                  <span className="reset-password-form-label">Confirmação da senha:</span>
                  <Input
                    className="login-form-input"
                    danger={errors.passwordConfirmation}
                    value={values.passwordConfirmation}
                    onChange={e => this.update("passwordConfirmation", e.target.value)}
                    placeholder="****"
                    type="password"
                  />
                  <p className="help is-danger reset-password-form-info">{errors.passwordConfirmation}</p>
                </Control>
              </div>
              <Button gradientLink large className="btn reset-password-form-button" onClick={this.doRegister}>
                REDEFINIR
              </Button>
            </Box>
          </div>
        </div>
      </Fragment>
    );
  }
}

ResetPassword.displayName = "ResetPassword";

export default ResetPassword;
